/**
 * JavaScript client for [Onvio Security Services API](https://demo.onvio.us/swagger/).
 *
 * @packageDocumentation
 */
/* istanbul ignore file */
import { registerLibrary } from '@onviobr/app-information';
import * as environment from './environment.js';
import * as featureResourcePermissions from './feature-resource-permissions.js';
import * as infrastructureAccessControls from './infrastructure-access-controls.js';
export { hasFirmSomeLicense, hasFirmEveryLicense } from './licenses.js';
export { getSessionAndBindingsV1, getContactID, getCompanyID, getVerticalRoute, getIACs, getFRPsV1, createJWT, createSession, createSessionWithJWT, createSessionWithSSO, retrieveSessionWithSSO, createSSOToken, deleteSession, } from './security-services.js';
export { sessionManager, SessionManager } from './session-manager.js';
export { SecureHttp } from './secure-http.js';
export { sessionNgProvider } from './ng-injector.js';
export { environment, featureResourcePermissions, infrastructureAccessControls };
registerLibrary({
    name: '@onviobr/security-services',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    version: "2.2.0",
});
